import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {TableReportModel} from "./table-report.model";

@Component({
    selector: "wbo-table-report",
    templateUrl: "./table-report.component.html",
    providers: [provideReportModel(TableReportModel)]
})
export class TableReportComponent extends AbstractReportPage {
    constructor(public model: TableReportModel) {
        super();
    }

}
